export default __webpack_public_path__ + "static/media/mark-attendance-enabled.21d2f870.svg";